import axios from "@/utils/axios";
import Qs from "qs";
export default {
  /**
   * 获取字段字典
   * @param {*} fieldName 字段名
   * @returns
   */
  dictionaryList(fieldName) {
    return axios.get("/dictionary/list", {
      params: {
        fieldName,
      },
    });
  },

  // 修改字典
  modifyDictionary(data) {
    return axios.post("dictionary/modifyDictionary", data);
  },

  /**
   * 获取收支类型
   * @param {*} pid 为0获取顶层类型
   * @returns
   */
  incomeType(pid) {
    return axios.get("/dictionary/incomeType", {
      params: {
        pid,
      },
    });
  },

  // 获取审核状态字典
  auditState() {
    return axios.get("/dictionary/auditState");
  },

  // 获取导入收支类型
  importIncomeType(data) {
    return axios.get("/dictionary/importIncomeType", {
      params: {
        ...data,
      },
    });
  },

  // 帮扶措施类型列表
  measureTypes(code) {
    return axios.post(
      "/monitor-measure/types",
      Qs.stringify({
        code,
      })
    );
  },

  // 帮扶措施类型列表
  measureAllTypes() {
    return axios.post("/monitor-measure/all_types");
  },
};
